import { ComponentFactoryResolver, EventEmitter, Injectable, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ButtonBarButton } from '../../shared-module/buttons/button-bar-button';
import { DefinitionListItemComponent } from '../definition-list-item/definition-list-item.component';
import { CrosswordWordModel } from '../models/crossword-word.model';

@Injectable({
  providedIn: 'root',
})
export class DefinitionsListService {
  private viewContainer: ViewContainerRef;
  private injectViewContainer: ViewContainerRef;

  private buttons: BehaviorSubject<Array<ButtonBarButton>> = new BehaviorSubject<Array<ButtonBarButton>>([]);
  public buttons$: Observable<Array<ButtonBarButton>> = this.buttons.asObservable();

  private currentWord: BehaviorSubject<CrosswordWordModel> = new BehaviorSubject<CrosswordWordModel>(null);
  public readonly currentWord$: Observable<CrosswordWordModel> = this.currentWord.asObservable();

  // public definitionListRegistered: EventEmitter<null> = new EventEmitter<null>();

  private definitionListRegistered: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly definitionListRegistered$: Observable<boolean> = this.definitionListRegistered.asObservable();

  private listItems: BehaviorSubject<CrosswordWordModel[]> = new BehaviorSubject<CrosswordWordModel[]>([]);
  public readonly listItems$: Observable<CrosswordWordModel[]> = this.listItems.asObservable();

  update: EventEmitter<null> = new EventEmitter<null>();

  constructor(private factoryResolver: ComponentFactoryResolver) {}

  registerViewContainer(viewContainerRef: ViewContainerRef, injectViewContainer: ViewContainerRef, direction = '') {
    this.viewContainer = viewContainerRef;
    this.injectViewContainer = injectViewContainer;
    this.definitionListRegistered.next(true);
  }

  registerSidebar() {
    this.definitionListRegistered.next(true);
  }

  injectListItem(ComponentClass, data: any = {}) {
    const factory = this.factoryResolver.resolveComponentFactory(ComponentClass);
    const component = factory.create(this.viewContainer.injector);
    const instance = component.instance as DefinitionListItemComponent;
    // instance.setData(data);
    this.injectViewContainer.insert(component.hostView);
    return instance;
  }

  scrollTo(item) {}

  setCurrentWord(word: CrosswordWordModel) {
    this.currentWord.next(word);
  }

  setItems(listItems: CrosswordWordModel[]) {
    this.listItems.next(listItems);
  }
}
